<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-building"></i> {{ "LABEL.ENTERPRISE" | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="balanceForm">
      <label for="nameInput2">{{ "LABEL.CURRENT-BALANCE" | translate }}</label>
      <div class="form-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-hand-holding-usd"></i>
          </div>
          <input type="text"
                 id="nameInput2"
                 class="form-control custom-input"
                 placeholder="{{ 'LABEL.CURRENT-BALANCE' | translate }}"
                 formControlName="actualBalance"
                 [(ngModel)]="actualBalance">
        </div>
      </div>
      <label for="nameInput">{{ "LABEL.ASSIGN-BALANCE" | translate }}</label>
      <div class="form-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fas fa-money-check-alt"></i>
          </div>
          <input type="text"
                 id="nameInput"
                 class="form-control"
                 placeholder="{{ 'MESSAGE.ENTER-BALANCE-TO-ASSIGN' | translate }}"
                 [(ngModel)]="headbalanceallocation.quantity"
                 formControlName="additionalBalance"
                 [class.is-invalid]="isInvalidControl('additionalBalance')">
        </div>
      </div>
      <small *ngIf="isInvalidControl('additionalBalance')"
             class="text-danger">
        {{ "MESSAGE.ENTER-BALANCE-ASSIGNMENT" | translate }}
      </small>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success" (click)="save()">
      <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger" (click)="cancel()">
      <i class="fa fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
